var _rect, _path, _g, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 182,
    viewBox: "0 0 221 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 71.0178,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1696_41599)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 40.3227C105.039 38.8193 110.247 38.7821 115.14 40.2157L201.676 65.5645C207.399 67.241 207.437 75.3351 201.729 77.0647L115.378 103.232C110.337 104.759 104.95 104.72 99.9323 103.118L18.214 77.0381C12.618 75.2521 12.6564 67.3204 18.2695 65.5888L100.166 40.3227Z",
    fill: "#3D3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1696_41599)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 69.0178,
    rx: 26.5,
    ry: 2,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.333 5.83325H120.957C118.359 5.83325 117.058 8.9745 118.895 10.812L122.917 14.8341L111.146 26.6058C107.29 30.4616 105.167 35.5891 105.167 41.0433V49.5833H116.833V41.0403C116.833 38.7041 117.743 36.5049 119.394 34.8512L131.166 23.0795L135.188 27.1016C137.025 28.942 140.167 27.6412 140.167 25.0424V11.6666C140.167 8.44367 137.556 5.83325 134.333 5.83325Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8335 11.6666V25.0424C81.8335 27.6412 84.9747 28.942 86.8122 27.1045L90.8345 23.0823L102.606 34.8512C104.245 36.4932 105.167 38.7187 105.167 41.0374V61.2499C105.167 62.8599 106.473 64.1666 108.083 64.1666H113.917C115.527 64.1666 116.833 62.8599 116.833 61.2499V41.0432C116.833 35.627 114.684 30.4353 110.854 26.6057L99.0827 14.8341L103.105 10.812C104.942 8.9745 103.641 5.83325 101.043 5.83325H87.6668C84.4439 5.83325 81.8335 8.44367 81.8335 11.6666Z",
    fill: "url(#paint1_linear_1696_41599)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1696_41599",
    x: 69,
    y: 53.0178,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1696_41599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1696_41599",
    x1: 206,
    y1: 126.018,
    x2: 14,
    y2: 126.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1696_41599",
    x1: 83.0002,
    y1: 6.99995,
    x2: 116.25,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDark);
export default __webpack_public_path__ + "static/media/illustration-dark.688f7e9d9e01e25633141330303cc572.svg";
export { ForwardRef as ReactComponent };